import { Fragment } from 'react';
import { Portal } from '@chakra-ui/react';
import ControlButton, { ControlButtonProps } from '../ControlButton/ControlButton';
import Menu, { MenuProps } from '../Menu/Menu';
import MenuButton from '../Menu/MenuButton';
import MenuList, { MenuListProps } from '../Menu/MenuList';

export interface OverflowMenuProps extends MenuProps {
  children: MenuListProps['children'];
  buttonProps?: ControlButtonProps;
  buttonSize?: ControlButtonProps['size'];
  triggerLabel?: string;
  withPortal?: boolean;
}

const OverflowMenu = ({
  buttonProps,
  buttonSize = 'sm',
  children,
  triggerLabel = 'Open menu',
  withPortal,
  ...rest
}: OverflowMenuProps) => {
  const Wrapper = withPortal ? Portal : Fragment;

  return (
    <Menu isLazy {...rest}>
      <MenuButton
        aria-label={triggerLabel}
        as={ControlButton}
        iconName="MoreVertical"
        isTooltipDisabled
        size={buttonSize}
        {...buttonProps}
      />
      <Wrapper>
        <MenuList>{children}</MenuList>
      </Wrapper>
    </Menu>
  );
};

export default OverflowMenu;
